module.exports = __webpack_public_path__ + "static/FAQ-team1-9466f9852e54a41c24091fee4e81bd44.jpg";